export default __webpack_public_path__ + "static/media/pic_product_04.8ea2bd80.jpg";